import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ENVIRONMENT } from '@environment';

@Injectable({
    providedIn: 'root',
})
export class AdminClientsService {

    readonly environment = inject(ENVIRONMENT);
    readonly http: HttpClient = inject(HttpClient);

    private readonly path: string = this.environment.apiUrl + 'Admin/Clients/';

    public syncClient(clientId: number, domain: 'ALL' | 'HEALTH' | 'AUTOFLEET', healthContext: 'EB' = 'EB') {
        let params = { syncDataDesc: domain, healthContext}
        return this.http.post(`${this.path}${clientId}/SyncData`, {}, { params });
    }

}
